import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { Uploader, Form, Schema, Animation, Button } from 'rsuite';
import FileBase64 from 'react-file-base64';
import $ from "jquery";


function withParams(Component) {
    return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}

const model_profile = Schema.Model({
    name_full: Schema.Types.StringType().isRequired('این فیلد الزامی است.').minLength(7, 'لطفا نام خود را به صورت کامل وارد نمایید').pattern(/[آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ]/, 'Please enter legal characters'),
    email: Schema.Types.StringType().isEmail('ایمیل وارد شده صحیح نمی باشد'),
    age: Schema.Types.NumberType('فقط عدد وارد نمایید.').isRequired('این فیلد الزامی است.').isInteger('فقط عدد وارد نمایید.').min(1, 'سن وارد شده صحیح نمی باشد.').max(99, 'سن وارد شده صحیح نمی باشد.'),
    tall: Schema.Types.NumberType('فقط عدد وارد نمایید.').isRequired('این فیلد الزامی است.').isInteger('فقط عدد وارد نمایید.').min(1, 'قد وارد شده صحیح نمی باشد.').max(300, 'قد وارد شده صحیح نمی باشد.'),
    weight: Schema.Types.NumberType('فقط عدد وارد نمایید.').isRequired('این فیلد الزامی است.').isInteger('فقط عدد وارد نمایید.').min(1, 'وزن وارد شده صحیح نمی باشد.').max(500, 'وزن وارد شده صحیح نمی باشد.'),
});


export class Profile_Edit extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            profile: null,
            avatar: localStorage.getItem('avatar'),
        };

    }


    // ---------------- componentDidMount--------------------------

    componentDidMount() {

        Send('page/profile/info', "", true).then((res) => {
            this.setState({ profile: res.data.profile });
        }).catch((err) => { });

        H1.NavHide();

    }

    // ---------------- componentWillUnmount-----------------------


    componentWillUnmount() {

        H1.NavShow();
    }


    // ------------------------- do_edit ----------------------------
    do_edit = () => {


        this.setState({ loader_1: true });

        let data = this.state.profile;


        Send('page/profile/edit', data, true).then((res) => {
            H1.notfy_success(res.message)
            this.setState({ loader_1: false });
        }).catch((err) => {
            this.setState({ loader_1: false });
        });

    }


    /* -------------------------------------------------------------------------- */
    /*                                  getFiles                                  */
    /* -------------------------------------------------------------------------- */
    getFiles = (files) => {

        var file_size = files["size"].replace(/\D/g, "");
        if (Number(file_size) > 400) {

            H1.notfy_error('حداکثر سایز مجاز عکس 400 کیلیوبایت میباشد.')

        }
        else {


            let data = {
                avatar: files.base64
            }


            Send('page/profile/edit/avatar', data, true).then((res) => {
                H1.notfy_success(res.message)
                this.setState({ avatar : files.base64 });
                H1.new_avatar(files.base64);
            }).catch((err) => { });



        }


    }
    /* -------------------------------------------------------------------------- */
    /*                                 open_input                                 */
    /* -------------------------------------------------------------------------- */
    open_input = (e) => {
        $('#change_avatar_sec input').trigger('click');
    }




    render() {



        return !this.state.profile ? null : (

            <div className="h-100 mt-4">

                <div className='c-row'>


                    <div className="text-center mb-2 py-2 position-relative">

                        <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.props.navigation(-1)}></span>
                        <span className='fs-6'>ویرایش حساب</span>

                    </div>


                </div>



                <div className="c-row text-center mt-4">
                    <Animation.Slide in={true} placement="top">



                        <div className="position-relative d-inline-block" onClick={() => $('#avatar_in input').trigger('click')}>
                            <img src={this.state.avatar} width="85" height="85" className='rounded-50 rounded-circle' />
                            <div className="fs-3 position-absolute top-50 start-50 translate-middle">  <span className="icon-Camera cc-1 avatar_change_btn"></span>    </div>
                        </div>


                    </Animation.Slide>

                    <div className="d-none" id="avatar_in">
                        <FileBase64
                            multiple={false}
                            onDone={this.getFiles.bind(this)} />
                    </div>

                </div>


                <div className="c-row text-center mt-4">


                    <Form model={model_profile} checkTrigger='none' formDefaultValue={this.state.profile} noValidate={true} align="middle" onChange={(val) => this.setState({ profile: val })} onCheck={(e) => H1.isEmpty(e) && this.do_edit()} >


                        <Form.Group controlId="name">
                            <Form.ControlLabel className="px-2" align="right">نام کامل</Form.ControlLabel>
                            <Form.Control id="in_r_name" name="name_full" type="text" className='py-3 in_s1' placeholder='میلاد قیاسی' />
                        </Form.Group>

                        <Form.Group controlId="email">
                            <Form.ControlLabel className="px-2" align="right"> ایمیل</Form.ControlLabel>
                            <Form.Control  disabled={this.state.profile && this.state.profile.number.length > 11  ? true :  false } id="in_r_name" name="email" type="email" className='py-3 in_s1' placeholder='example@mail.com' />
                        </Form.Group>


                        <Form.Group controlId="age">
                            <Form.ControlLabel className="px-2" align="right">سن</Form.ControlLabel>
                            <Form.Control id="in_r_name" name="age" type="tel" pattern="[0-9]*" inputMode="numeric" className='py-3 in_s1 NumOnly' placeholder='به سال وارد نمایید' />
                        </Form.Group>


                        <Form.Group controlId="tall">
                            <Form.ControlLabel className="px-2" align="right">قد</Form.ControlLabel>
                            <Form.Control id="in_r_name" name="tall" type="tel" pattern="[0-9]*" inputMode="numeric" className='py-3 in_s1 NumOnly' placeholder='به سانتی‌متر وارد نمایید' />
                        </Form.Group>

                        <Form.Group controlId="weight">
                            <Form.ControlLabel className="px-2" align="right">وزن</Form.ControlLabel>
                            <Form.Control id="in_r_name" name="weight" type="tel" pattern="[0-9]*" inputMode="numeric" className='py-3 in_s1 NumOnly' placeholder='به کیلوگرم وارد نمایید' />
                        </Form.Group>


                        <Button appearance="primary" type="submit" block className='fw-light btn_s1 mt-5 mx-auto' loading={this.state.loader_1}>ثبت تغییرات</Button>


                    </Form>


                </div>




            </div>

        )

    }
}

export default withParams(Profile_Edit);
